import React, { useEffect, useState } from "react";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import CustomInput from "components/CustomInput/CustomOutlinedInput";
import Button from "components/CustomButtons/CustomButton";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";

import { useDispatch } from "react-redux";

import CustomModal from "components/CustomModal/Modal.js";
import SweetAlert from "react-bootstrap-sweetalert";
import { RotatingLines } from "react-loader-spinner";
import Snackbar from "components/Snackbar/Snackbar.js";

import { useTranslation } from "react-i18next";

import { sanatizeMessageHtml } from "components/Utils/utils.js";

import { getRates, saveRates } from "views/Services/RatesService";

const TABS = [
  { key: "gap", label: "Gap Coverage" },
  { key: "premiere", label: "Premiere Package Coverage" },
  { key: "liabilitybi", label: "Liability BI" },
  { key: "liabilitypd", label: "Liability PD" },
  { key: "csl", label: "Combined Single Limit" },
  { key: "excessliab", label: "Excess Liability" },
  { key: "medical", label: "Medical Coverage" },
  { key: "pd", label: "Physical Damage" },
  { key: "theft", label: "Theft" },
  { key: "base_rates", label: "Base Rates Coverage" },
  { key: "discounts", label: "Discounts" },
  { key: "special_discounts", label: "Special Discounts" },
  { key: "packages", label: "Packages" },
  { key: "fixed_deductible", label: "Fixed Deductible" },
  { key: "surcharges", label: "Surcharges" },
];

const INITIAL_FIELDS = {
  gap: {
    "gap-value": { value: "", label: "Gap Percentage" },
  },

  premiere: {
    "premiere-value": { value: "", label: "Premiere Percentage" },
  },

  liabilitybi: {
    "liab_bi-10_20": { value: "", label: "10/20" },
    "liab_bi-25_50": { value: "", label: "25/50" },
    "liab_bi-30_60": { value: "", label: "30/60" },
    "liab_bi-40_80": { value: "", label: "40/80" },
    "liab_bi-50_100": { value: "", label: "50/100" },
    "liab_bi-75_150": { value: "", label: "75/150" },
    "liab_bi-100_200": { value: "", label: "100/200" },
    "liab_bi-multiplier": { value: "", label: "Multiplier" },
  },

  liabilitypd: {
    "liab_pd-10": { value: "", label: "10" },
    "liab_pd-25": { value: "", label: "25" },
    "liab_pd-30": { value: "", label: "30" },
    "liab_pd-50": { value: "", label: "50" },
    "liab_pd-75": { value: "", label: "75" },
    "liab_pd-100": { value: "", label: "100" },
    "liab_pd-150": { value: "", label: "150" },
    "liab_pd-multiplier": { value: "", label: "Multiplier" },
  },

  csl: {
    "csl-50000": { value: "", label: "50000" },
    "csl-60000": { value: "", label: "60000" },
    "csl-70000": { value: "", label: "70000" },
    "csl-80000": { value: "", label: "80000" },
    "csl-90000": { value: "", label: "90000" },
    "csl-100000": { value: "", label: "100000" },
    "csl-150000": { value: "", label: "150000" },
    "csl-200000": { value: "", label: "200000" },
    "csl-300000": { value: "", label: "300000" },
    "csl-400000": { value: "", label: "400000" },
    "csl-500000": { value: "", label: "500000" },
    "csl-1000000": { value: "", label: "1000000" },
    "csl-multiplier": { value: "", label: "Multiplier" },
    "csl_sb_discount-50000": { value: "", label: "SB 50000" },
    "csl_sb_discount-60000": { value: "", label: "SB 60000" },
    "csl_sb_discount-70000": { value: "", label: "SB 70000" },
    "csl_sb_discount-80000": { value: "", label: "SB 80000" },
    "csl_sb_discount-90000": { value: "", label: "SB 90000" },
    "csl_sb_discount-100000": { value: "", label: "SB 100000" },
    "csl_sb_discount-150000": { value: "", label: "SB 150000" },
    "csl_sb_discount-200000": { value: "", label: "SB 200000" },
    "csl_sb_discount-300000": { value: "", label: "SB 300000" },
    "csl_sb_discount-400000": { value: "", label: "SB 400000" },
    "csl_sb_discount-500000": { value: "", label: "SB 500000" },
    "csl_sb_discount-1000000": { value: "", label: "SB 1000000" },
    "csl_sb_discount-multiplier": { value: "", label: "SB Multiplier" },
  },

  excessliab: {
    "excessLiab-150000": { value: "", label: "150000" },
    "excessLiab-300000": { value: "", label: "300000" },
  },

  medical: {
    "medical-2000": { value: "", label: "2000" },
    "medical-3000": { value: "", label: "3000" },
    "medical-5000": { value: "", label: "5000" },
    "medical-10000": { value: "", label: "10000" },
    "medical-15000": { value: "", label: "15000" },
    "medical-20000": { value: "", label: "20000" },
    "medical-multiplier": { value: "", label: "Multiplier" },
    "medical_sb_discount-2000": { value: "", label: "SB 2000" },
    "medical_sb_discount-3000": { value: "", label: "SB 3000" },
    "medical_sb_discount-5000": { value: "", label: "SB 5000" },
    "medical_sb_discount-10000": { value: "", label: "SB 10000" },
    "medical_sb_discount-15000": { value: "", label: "SB 15000" },
    "medical_sb_discount-20000": { value: "", label: "SB 20000" },
    "medical_sb_discount-multiplier": { value: "", label: "SB Multiplier" },
  },

  pd: {},

  theft: {},

  base_rates: {
    "legal-value": { value: "", label: "Legal Aid / Bail Bond" },
    "roadside-value": { value: "", label: "Roadside Assistance" },
    "roadside-premiere": { value: "", label: "Roadside Assistance Premiere" },
  },

  discounts: {
    "discount-6": { value: "", label: "6 Days" },
    "discount-28": { value: "", label: "28 Days" },
    "discount-29": { value: "", label: "29 Days" },
    "discount-39": { value: "", label: "39 Days" },
    "discount-49": { value: "", label: "49 Days" },
    "discount-59": { value: "", label: "59 Days" },
    "discount-69": { value: "", label: "69 Days" },
    "discount-79": { value: "", label: "79 Days" },
    "discount-89": { value: "", label: "89 Days" },
    "discount-119": { value: "", label: "119 Days" },
    "discount-149": { value: "", label: "149 Days" },
    "discount-179": { value: "", label: "179 Days" },
    "discount-209": { value: "", label: "209 Days" },
    "discount-239": { value: "", label: "239 Days" },
    "discount-269": { value: "", label: "269 Days" },
    "discount-299": { value: "", label: "299 Days" },
    "discount-329": { value: "", label: "329 Days" },
    "discount-359": { value: "", label: "359 Days" },
    "discount-365": { value: "", label: "365 Days" },
  },

  special_discounts: {
    "special_discount-all_mexico_semi": {
      value: "",
      label: "All of Mexico Semi-Annual",
    },
    "special_discount-all_mexico_annual": {
      value: "",
      label: "All of Mexico Annual",
    },
    "special_discount-comercial_semi": {
      value: "",
      label: "Commercial/Business Semi-Annual",
    },
    "special_discount-comercial_annual": {
      value: "",
      label: "Commercial/Business Annual",
    },
    "special_discount-sonora_semi": {
      value: "",
      label: "Sonora Semi-Annual",
    },
    "special_discount-sonora_annual": {
      value: "",
      label: "Sonora Annual",
    },
    "special_discount-sanborns_sonora_semi": {
      value: "",
      label: "Sanborn's Sonora Semi-Annual",
    },
    "special_discount-sanborns_sonora_annual": {
      value: "",
      label: "Sanborn's Sonora Annual",
    },
    "special_discount-baja_only_semi": {
      value: "",
      label: "Baja Only Semi-Annual",
    },
    "special_discount-baja_only_annual": {
      value: "",
      label: "Baja Only Annual",
    },
    "special_discount-sanborns_baja_only_semi": {
      value: "",
      label: "Sanborn's Baja Only Semi-Annual",
    },
    "special_discount-sanborns_baja_only_annual": {
      value: "",
      label: "Sanborn's Baja Only Annual",
    },
    "special_discount-sanborns_other_borders_semi": {
      value: "",
      label: "Sanborn's Other Borders All of Mexico Semi-Annual",
    },
    "special_discount-sanborns_other_borders_annual": {
      value: "",
      label: "Sanborn's Other Borders All of Mexico Annual",
    },
    "special_discount-sanborns_tx_borders_semi": {
      value: "",
      label: "Sanborn's TX Border All of Mexico Semi-Annual",
    },
    "special_discount-sanborns_tx_borders_annual": {
      value: "",
      label: "Sanborn's TX Border All of Mexico Annual",
    },
    "special_discount-driver_lic_semi": {
      value: "",
      label: "Drivers License Semi-Annual",
    },
    "special_discount-driver_lic_annual": {
      value: "",
      label: "Drivers License Annual",
    },
    "special_discount-sentri_annual": {
      value: "",
      label: "Sentri (Annual Only)",
    },
    "special_discount-caravan_daily": { value: "", label: "Caravan" },
    "special_discount-sanborns_sonora_baja_semi": {
      value: "",
      label: "Sanborn's Sonora & Baja Semi-Annual",
    },
    "special_discount-sanborns_sonora_baja_annual": {
      value: "",
      label: "Sanborn's Sonora & Baja Annual",
    },
    "special_discount-sonora_baja_semi": {
      value: "",
      label: "Sonora & Baja Semi-Annual",
    },
    "special_discount-sonora_baja_annual": {
      value: "",
      label: "Sonora & Baja Annual",
    },
    "special_discount-arriba_semi": { value: "", label: "Arriba Semi-Annual" },
    "special_discount-arriba_annual": { value: "", label: "Arriba Annual" },
    "special_discount-all_mexico_tri": {
      value: "",
      label: "All of Mexico Quarterly",
    },
    "special_discount-comercial_tri": {
      value: "",
      label: "Commercial/Business Quarterly",
    },
    "special_discount-sanborns_other_borders_tri": {
      value: "",
      label: "Sanborn's Other Borders All of Mexico Quarterly",
    },
    "special_discount-sanborns_tx_borders_tri": {
      value: "",
      label: "Sanborn's TX Border All of Mexico Quarterly",
    },
    "special_discount-driver_lic_tri": {
      value: "",
      label: "Drivers License Quarterly",
    },
    "special_discount-sanborns_sonora_baja_tri": {
      value: "",
      label: "Sanborn's Sonora & Baja Quarterly",
    },
    "special_discount-sonora_baja_tri": {
      value: "",
      label: "Sonora & Baja Quarterly",
    },
    "special_discount-arriba_tri": { value: "", label: "Arriba Quarterly" },
  },

  packages: {
    "caravan-apv_liability": { value: "", label: "Caravan APV Liability Only" },
    "caravan-apv_5k": { value: "", label: "Caravan APV < $5k" },
    "caravan-apv_10k": { value: "", label: "Caravan APV < $10k" },
    "caravan-apv_15k": { value: "", label: "Caravan APV < $15k" },
    "caravan-apv_20k": { value: "", label: "Caravan APV < $20k" },
    "caravan-apv_25k": { value: "", label: "Caravan APV < $25k" },
    "caravan-apv_30k": { value: "", label: "Caravan APV < $30k" },
    "caravan-apv_35k": { value: "", label: "Caravan APV < $35k" },
    "caravan-apv_40k": { value: "", label: "Caravan APV < $40k" },
    "caravan-apv_45k": { value: "", label: "Caravan APV < $45k" },
    "caravan-apv_50k": { value: "", label: "Caravan APV < $50k" },
    "caravan-apv_55k": { value: "", label: "Caravan APV < $55k" },
    "caravan-apv_60k": { value: "", label: "Caravan APV < $60k" },
    "caravan-apv_65k": { value: "", label: "Caravan APV < $65k" },
    "caravan-apv_70k": { value: "", label: "Caravan APV < $70k" },
    "caravan-apv_75k": { value: "", label: "Caravan APV < $75k" },
    "caravan-apv_80k": { value: "", label: "Caravan APV < $80k" },
    "caravan-apv_85k": { value: "", label: "Caravan APV < $85k" },
    "caravan-apv_90k": { value: "", label: "Caravan APV < $90k" },
    "caravan-apv_95k": { value: "", label: "Caravan APV < $95k" },
    "caravan-apv_100k": { value: "", label: "Caravan APV < $100k" },
    "caravan-suv_liability": {
      value: "",
      label: "Caravan SUV/Lux Liability Only",
    },
    "caravan-suv_5k": { value: "", label: "Caravan SUV/Lux < $5k" },
    "caravan-suv_10k": { value: "", label: "Caravan SUV/Lux < $10k" },
    "caravan-suv_15k": { value: "", label: "Caravan SUV/Lux < $15k" },
    "caravan-suv_20k": { value: "", label: "Caravan SUV/Lux < $20k" },
    "caravan-suv_25k": { value: "", label: "Caravan SUV/Lux < $25k" },
    "caravan-suv_30k": { value: "", label: "Caravan SUV/Lux < $30k" },
    "caravan-suv_35k": { value: "", label: "Caravan SUV/Lux < $35k" },
    "caravan-suv_40k": { value: "", label: "Caravan SUV/Lux < $40k" },
    "caravan-suv_45k": { value: "", label: "Caravan SUV/Lux < $45k" },
    "caravan-suv_50k": { value: "", label: "Caravan SUV/Lux < $50k" },
    "caravan-suv_55k": { value: "", label: "Caravan SUV/Lux < $55k" },
    "caravan-suv_60k": { value: "", label: "Caravan SUV/Lux < $60k" },
    "caravan-suv_65k": { value: "", label: "Caravan SUV/Lux < $65k" },
    "caravan-suv_70k": { value: "", label: "Caravan SUV/Lux < $70k" },
    "caravan-suv_75k": { value: "", label: "Caravan SUV/Lux < $75k" },
    "caravan-suv_80k": { value: "", label: "Caravan SUV/Lux < $80k" },
    "caravan-suv_85k": { value: "", label: "Caravan SUV/Lux < $85k" },
    "caravan-suv_90k": { value: "", label: "Caravan SUV/Lux < $90k" },
    "caravan-suv_95k": { value: "", label: "Caravan SUV/Lux < $95k" },
    "caravan-suv_100k": { value: "", label: "Caravan SUV/Lux < $100k" },
    "caravan-rv_liability": { value: "", label: "Caravan RVs Liability Only" },
    "caravan-rv_15k": { value: "", label: "Caravan RVs < $15k" },
    "caravan-rv_25k": { value: "", label: "Caravan RVs < $25k" },
    "caravan-rv_35k": { value: "", label: "Caravan RVs < $35k" },
    "caravan-rv_45k": { value: "", label: "Caravan RVs < $45k" },
    "caravan-rv_55k": { value: "", label: "Caravan RVs < $55k" },
    "caravan-rv_60k": { value: "", label: "Caravan RVs < $60k" },
    "caravan-rv_65k": { value: "", label: "Caravan RVs < $65k" },
    "caravan-rv_70k": { value: "", label: "Caravan RVs < $70k" },
    "caravan-rv_75k": { value: "", label: "Caravan RVs < $75k" },
    "caravan-rv_80k": { value: "", label: "Caravan RVs < $80k" },
    "caravan-rv_85k": { value: "", label: "Caravan RVs < $85k" },
    "caravan-rv_90k": { value: "", label: "Caravan RVs < $90k" },
    "caravan-rv_95k": { value: "", label: "Caravan RVs < $95k" },
    "caravan-rv_100k": { value: "", label: "Caravan RVs < $100k" },
    "caravan-rv_125k": { value: "", label: "Caravan RVs < $125k" },
    "caravan-rv_150k": { value: "", label: "Caravan RVs < $150k" },
    "caravan-rv_175k": { value: "", label: "Caravan RVs < $175k" },
    "caravan-rv_200k": { value: "", label: "Caravan RVs < $200k" },
    "caravan-rv_225k": { value: "", label: "Caravan RVs < $225k" },
    "caravan-rv_250k": { value: "", label: "Caravan RVs < $250k" },
    "caravan-rv_275k": { value: "", label: "Caravan RVs < $275k" },
    "caravan-rv_300k": { value: "", label: "Caravan RVs < $300k" },
    "caravan-package_policy_fee": { value: "", label: "Package Policy Fee" },
    "caravan-package_agency_fee": { value: "", label: "Package Agency Fee" },
  },

  fixed_deductible: {
    "fixed_deductible_surcharge-value": {
      value: "",
      label: "Fixed Deductible Surcharge",
    },
  },

  surcharges: {
    "motorcycle_surcharge-value": { value: "", label: "Motorcycle surcharge" },
    "bus_surcharge-value": { value: "", label: "Bus surcharge" },
    "trailer_surcharge-value": { value: "", label: "Trailer surcharge" },
    "luxury_rate-value": { value: "", label: "Luxury rate" },
    "high_risk_rate-value": { value: "", label: "High risk rate" },
    "high_risk_rate2-value": { value: "", label: "High risk rate 2" },
    "iva_rate-value": { value: "", label: "Iva rate" },
    "border_cross-ar": { value: "", label: "Border Crossing AZ" },
    "border_cross-mn": { value: "", label: "Border Crossing NM" },
    "border_cross-tx": { value: "", label: "Border Crossing TX" },
    "border_cross-ca": { value: "", label: "Border Crossing CA" },
    "border_cross-az": { value: "", label: "Border Crossing DG" },
  },
};

function RatesForm() {
  const dispatch = useDispatch();
  const [tab, setTab] = useState(0);
  const [fields, setFields] = useState(INITIAL_FIELDS);

  const { t } = useTranslation();

  const [alertLoading, setAlertLoading] = React.useState(null);
  const [orderDataSuccess, setOrderDataSuccess] = useState({});
  const [modalSuccess, setModalSuccess] = useState(false);
  const [messageToast, setMessageToast] = useState("");
  const [toastMessage, setToastMessage] = useState(false);
  const [typeToast, setTypeToast] = useState("danger");

  const handleTabChange = (event, newValue) => setTab(newValue);

  const handleInputChange = (e, tabKey) => {
    const { name, value } = e.target;
    let currentDataField = { ...fields };
    currentDataField[tabKey][name]["value"] = value;
    setFields(currentDataField);
  };

  useEffect(() => {
    if (localStorage.getItem("userType") !== "1") {
      window.location.href = "/admin/home";
    }
    getCurrentRates();
  }, [dispatch]);

  const getCurrentRates = async () => {
    try {
      const response = await dispatch(getRates({}));
      if (response.payload.result) {
        // Map response rates to fields state
        const updatedFields = { ...fields };
        Object.entries(response.payload.rates).forEach(([key, row], index) => {
          switch (row.type) {
            case "gap":
              updatedFields["gap"]["gap-value"]["value"] = row.value;
              break;
            case "premiere":
              updatedFields["premiere"]["premiere-value"]["value"] = row.value;
              break;
            case "liab_bi":
              updatedFields["liabilitybi"][
                `${row.type}-${row["index"].replace("/", "_")}`
              ]["value"] = row.value;
              break;
            case "liab_pd":
              updatedFields["liabilitypd"][`${row.type}-${row.index}`][
                "value"
              ] = row.value;
              break;
            case "csl":
              updatedFields["csl"][`${row.type}-${row.index}`]["value"] =
                row.value;
              break;
            case "excessLiab":
              updatedFields["excessliab"][`${row.type}-${row.index}`]["value"] =
                row.value;
              break;
            case "medical":
              updatedFields["medical"][`${row.type}-${row.index}`]["value"] =
                row.value;
              break;
            case "medical_sb_discount":
              updatedFields["medical"][`${row.type}-${row.index}`]["value"] =
                row.value;
              break;
            case "theft":
              updatedFields["theft"][`${row.type}-${row.index}`] = {
                value: row.value,
                label: row.index,
              };
              break;
            case "pd":
              updatedFields["pd"][`${row.type}-${row.index}`] = {
                value: row.value,
                label: row.index,
              };
              break;
            case "legal":
              updatedFields["base_rates"][`${row.type}-${row.index}`] = {
                value: row.value,
                label: row.index,
              };
              break;
            case "roadside":
              updatedFields["base_rates"][`${row.type}-${row.index}`] = {
                value: row.value,
                label: row.index,
              };
              break;
            case "discount":
              updatedFields["discounts"][`${row.type}-${row.index}`]["value"] =
                row.value;
              break;
            case "special_discount":
              updatedFields["special_discounts"][`${row.type}-${row.index}`][
                "value"
              ] = row.value;
              break;
            case "caravan":
              console.log(`${row.type}-${row.index}`);
              updatedFields["packages"][`${row.type}-${row.index}`]["value"] =
                row.value;
              break;
            case "fixed_deductible_surcharge":
              updatedFields["fixed_deductible"][`${row.type}-${row.index}`][
                "value"
              ] = row.value;
              break;
            case "motorcycle_surcharge":
              updatedFields["surcharges"][`${row.type}-${row.index}`]["value"] =
                row.value;
              break;
            case "bus_surcharge":
              updatedFields["surcharges"][`${row.type}-${row.index}`]["value"] =
                row.value;
              break;
            case "trailer_surcharge":
              updatedFields["surcharges"][`${row.type}-${row.index}`]["value"] =
                row.value;
              break;
            case "luxury_rate":
              updatedFields["surcharges"][`${row.type}-${row.index}`]["value"] =
                row.value;
              break;
            case "high_risk_rate":
              updatedFields["surcharges"][`${row.type}-${row.index}`]["value"] =
                row.value;
              break;
            case "high_risk_rate2":
              updatedFields["surcharges"][`${row.type}-${row.index}`]["value"] =
                row.value;
              break;
            case "iva_rate":
              updatedFields["surcharges"][`${row.type}-${row.index}`]["value"] =
                row.value;
              break;
            case "border_cross":
              updatedFields["surcharges"][`${row.type}-${row.index}`]["value"] =
                row.value;
              break;
          }
        });
        setFields(updatedFields);
      } else {
        // Handle error in fetching rates
      }
    } catch (error) {
      // Handle unexpected error
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSave) onSave(fields);
  };

  const loadingAlert = () => {
    setAlertLoading(
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title={<h5 style={{ color: "black" }}>{"Loading"}</h5>}
        allowEscape={false}
        closeOnClickOutside={false}
        showConfirm={false}
        showCancel={false}
      >
        <RotatingLines
          strokeColor="gray"
          strokeWidth="5"
          animationDuration="0.75"
          width="96"
          visible={true}
        />
      </SweetAlert>
    );
  };

  const onSave = async () => {
    try {
      let ratesData = setDataRates();
      const response = await dispatch(saveRates(ratesData));
      if (response.payload.result) {
        setOrderDataSuccess(response.payload);
        setModalSuccess(true);
      } else {
        setMessageToast(response.payload.message);
        setToastMessage(true);
      }
    } catch (error) {
      // Handle unexpected error
    }
  };

  const setDataRates = () => {
    let ratesData = {};
    Object.entries(fields).forEach(([key, value]) => {
      Object.entries(value).forEach(([subKey, subValue]) => {
        ratesData[`${subKey}`] = subValue.value;
      });
    });
    return ratesData;
  };

  const onBack = () => {
    // Placeholder for back function
  };

  return (
    <GridContainer
      justifyContent="center"
      alignItems="center"
      xs={12}
      sm={12}
      md={8}
      style={{ margin: "auto" }}
    >
      <Card>
        <CardHeader color="success">
          <h4>Rates Management</h4>
        </CardHeader>
        <CardBody>
          <form onSubmit={handleSubmit}>
            <Tabs
              value={tab}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              style={{ minHeight: 48 }}
            >
              {TABS.map((t, idx) => (
                <Tab
                  key={t.key}
                  label={t.label}
                  style={{
                    minWidth: 120, // Ajusta este valor según lo que necesites
                    flex: 1,
                    maxWidth: "none",
                  }}
                />
              ))}
            </Tabs>
            <div style={{ marginTop: 24 }}>
              <GridContainer
                style={{
                  height: "auto",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "16px",
                }}
              >
                {Object.entries(fields[TABS[tab].key]).map(
                  ([key, { value, label }], index) => (
                    <GridItem xs={12} sm={6} md={4} key={key}>
                      <CustomInput
                        labelText={label}
                        inputProps={{
                          name: key,
                          value: value,
                          onChange: (e) => handleInputChange(e, TABS[tab].key),
                          type: "number",
                          required: true,
                        }}
                        formControlProps={{ fullWidth: true }}
                      />
                    </GridItem>
                  )
                )}
              </GridContainer>
              <GridContainer
                container
                justifyContent="space-between"
                alignItems="center"
                style={{ minHeight: "100px", marginTop: "20px" }}
              >
                <GridItem xs={4}>
                  <Button
                    id={"cancelUser"}
                    type="button"
                    variant="outlined"
                    onClick={(event) => {
                      window.location.href = "/admin/home/";
                    }}
                    style={{ width: "100%" }}
                  >
                    {t("Cancel")}
                  </Button>
                </GridItem>
                <GridItem xs={4} />
                <GridItem xs={4}>
                  <Button
                    id={"continueUser"}
                    type="submit"
                    variant="green"
                    style={{ width: "100%" }}
                  >
                    {t("creditCard.saveButton")}
                  </Button>
                </GridItem>
              </GridContainer>
            </div>
          </form>
          <CustomModal
            title=""
            isOpen={modalSuccess}
            onClose={() => {
              window.location.reload();
            }}
            privacy={false}
            id={"successModal"}
          >
            <GridContainer>
              <GridContainer>
                <GridItem xs={12}>
                  <div class="sa">
                    <div class="sa-success">
                      <div class="sa-success-tip"></div>
                      <div class="sa-success-long"></div>
                      <div class="sa-success-placeholder"></div>
                      <div class="sa-success-fix"></div>
                    </div>
                  </div>
                </GridItem>
              </GridContainer>
              <GridItem xs={12}>
                <p style={{ fontSize: "20px" }}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: sanatizeMessageHtml(orderDataSuccess.message),
                    }}
                  ></div>
                </p>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12}>
                <Button
                  id="continueUser"
                  type="submit"
                  variant="green"
                  onClick={() => {
                    window.location.reload();
                  }}
                  block
                >
                  Ok
                </Button>
              </GridItem>
            </GridContainer>
          </CustomModal>
          {alertLoading}
          <Snackbar
            style={{ zIndex: "3000" }}
            place="center"
            color={typeToast}
            message={messageToast}
            open={toastMessage}
            closeNotification={() => setToastMessage(false)}
            close
          />
        </CardBody>
      </Card>
    </GridContainer>
  );
}

export default RatesForm;
